import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import styled from "@emotion/styled";
import { setColor } from "../../../../assets/styles/styles";
import Typography from "../../../../components/common/text/Typography";
import { getAchievements, addAchievementToRoom } from "../../../../api/AchievementController";
import { ReactComponent as DropdownIcon } from "../../../../assets/images/icons/Chevron.svg";
import LoadingIcon from "../../../../components/common/loading/LoadingIcon";
import { default as Button } from "../../../../components/common/button/Button";
import Banner from "../../../../components/layout/ui/Banner";
import { DEFAULT_QUERY_OPTIONS } from "../../../../constants";

const AchievementsFields = ({ row }) => {
    const [metadata, setMetadata] = useState(row.metaData || {});
    const [stages, setStages] = useState(row.stages || {});
    const [icons, setIcons] = useState(row.icons || {});
    const [errorText, setErrorText] = useState("");
    const [successMessageBanner, setSuccessMessageBanner] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    return (
        <>
            <Banner
                width={"100%"}
                zIndex="1000"
                message={`${successMessageBanner}`}
                type={"SUCCESS"}
                openBanner={!!successMessageBanner}
                setOpenBanner={setSuccessMessageBanner}
                topDisplay
                showCloseButton
                gameScreen={false}
                top={"0px"}
                left={"0"}
            />
            <ModalContent>
                <GeneralContainer>
                    <Typography variant="h2PurpleHeading" margin={`0 0 0 0`}>
                        VIEW ACHIEVEMENT'S DATA
                    </Typography>

                    {isLoading && (
                        <LoadingDiv>
                            <LoadingIcon />
                        </LoadingDiv>
                    )}

                    {!isLoading && (
                        <>
                            <Card>
                                <Table>
                                    <TableRow>
                                        <TableColumn>
                                            <Label>Achievement Title</Label>
                                            <InputBox type="text" value={row.title} disabled />
                                        </TableColumn>
                                    </TableRow>

                                    <TableRow>
                                        <TableColumn>
                                            <Label>Metadata</Label>
                                            <TEXTAREA
                                                rows="5"
                                                value={JSON.stringify(metadata, null, 2)}
                                                onChange={(e) => setMetadata(JSON.parse(e.target.value))}
                                                placeholder="Enter metadata in JSON format"
                                            />
                                        </TableColumn>
                                    </TableRow>

                                    <TableRow>
                                        <TableColumn>
                                            <Label>Stages</Label>
                                            <TEXTAREA
                                                rows="5"
                                                value={JSON.stringify(stages, null, 2)}
                                                onChange={(e) => setStages(JSON.parse(e.target.value))}
                                                placeholder="Enter stages in JSON format"
                                            />
                                        </TableColumn>
                                    </TableRow>

                                    <TableRow>
                                        <TableColumn>
                                            <Label>Icons</Label>
                                            <TEXTAREA
                                                rows="5"
                                                value={JSON.stringify(icons, null, 2)}
                                                onChange={(e) => setIcons(JSON.parse(e.target.value))}
                                                placeholder="Enter icons in JSON format"
                                            />
                                        </TableColumn>
                                    </TableRow>
                                </Table>
                            </Card>
                        </>
                    )}
                </GeneralContainer>
            </ModalContent>
        </>
    );
};

export default AchievementsFields;

const TEXTAREA = styled.textarea`
    border: 1px solid ${setColor.grey1};
    border-radius: 5px;
    color: ${setColor.inputText};
    width: 100%;
    background-color: transparent;
`;

const LoadingDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    color: ${setColor.inputText};
`;

const Card = styled.div`
    width: 100%;
    height: auto;
    position: relative;
    padding: 20px;
    @media (max-width: 768px) {
        width: 100%;
        padding: 15px 0;
    }
`;

const GeneralContainer = styled.div`
    width: 100%;
    font-family: "Barlow-Regular", Helvetica;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const MessageNote = styled.div`
    font-size: 14px;
    color: ${setColor.inputText};
`;

const Table = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem;
    background: ${setColor.backgroundGrey};
    border-radius: 5px;
    margin-top: 15px;
`;

const TableRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
`;

const TableColumn = styled.div`
    flex: 1;
    padding: 5px;
`;

const Label = styled.div`
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
`;

const InputBox = styled.input`
    padding: 10px;
    border: ${(props) => (props.errorMessage ? `1px solid ${setColor.errorColor}` : `1px solid ${setColor.grey1}`)};
    border-radius: 5px;
    color: ${setColor.inputText};
    margin: 0rem 0rem 0rem 0rem;
    width: 100%;
    background-color: transparent;
    margin-bottom: ${(props) => (props.errorMessage ? "0.5rem" : "0rem")};
    &:disabled {
        background-color: ${setColor.grey1};
    }
`;
